export enum FinalSolutionTypesEnum {
  STATE_EMH = 'STATE_EMH',
  GP_EMH = 'GP_EMH',
  GP_LOCAL = 'GP_LOCAL',
  WHOLE_PARCEL = 'WHOLE_PARCEL',
  GP_VB = 'GP_VB',
  CANCELLED = 'CANCELLED',
  STATE_ZE = 'STATE_ZE',
  CHANGE_NEW_GP = 'CHANGE_NEW_GP',
  CHANGE_AREA_GEO = 'CHANGE_AREA_GEO',
  WHOLE_PARCEL_INVEST = 'WHOLE_PARCEL_INVEST',
  OTHER_CHANGE = 'OTHER_CHANGE',
  CANCELLED_INVEST = 'CANCELLED_INVEST',
}
